import React from 'react';
import {
  IoGridOutline,
  IoPeopleOutline,
  IoSettingsOutline,
  IoReceiptOutline,
  IoJournalOutline,
  IoBriefcaseOutline,
  IoLogOutOutline,
  IoShieldCheckmark,
  IoSearchOutline,
  IoBarChartOutline
} from 'react-icons/io5';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import './index.css';
import { useAuth } from '../../../context/AuthContext';
import {
  BsArrowLeft,
  BsPersonGear,
  BsAlarm,
  BsPersonLock,
  BsReceipt,
  BsBuildings,
  BsJournalText,
  BsPersonVcard,
} from "react-icons/bs";
import { RiListSettingsLine } from "react-icons/ri";
import Skeleton from 'react-loading-skeleton';
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { getAuth, signOut } from 'firebase/auth';

function SideBar({ sidenavCollapsed }) {

  const auth = getAuth();

  const navigate = useNavigate();
  const location = useLocation();
  const { user, businessProfile } = useAuth();

  function handleLogout() {
    signOut(auth).then(() => {
      navigate('/');
    });
  }

  return (
    <div className='sidebar'>
      <div className='sidebar-head'>
        <OverlayTrigger
          placement="right"
          overlay={
            <Tooltip id="tooltip-profile-right" className='profile-tooltip'>
              <div className='w-100 text-start p-1'>
                <h6 className='mb-0 fw-bold'>
                  {businessProfile && businessProfile.businessName}
                </h6>
                <p className='mb-0 fw-light'>
                  {user && user.email}
                </p>
              </div>
            </Tooltip>
          }
        >
          <Button
            variant='link'
            className='business-name w-100 mx-0 d-flex align-items-center justify-content-center'
            onClick={() => navigate('/admin/settings/company')}
          >
            <div className='company-logo'>
              <div className='logo'>
                {
                  businessProfile && businessProfile.companyLogo ?
                    <img
                      src={businessProfile.companyLogo}
                      width="38"
                      height="38"
                      className="rounded-circle d-inline-block align-top"
                      alt="company-logo"
                    />
                    :
                    <h3 className='mb-0 text-info'>A</h3>
                }
              </div>
            </div>
            <div className='company-name'>
              {
                businessProfile ?
                  <h6 className='text-ellipsis text-dark mb-0 fw-600'>{businessProfile && businessProfile.businessName}</h6>
                  :
                  <Skeleton height={18} />
              }
              {
                user ?
                  <div className='d-flex align-items-center'>
                    <IoShieldCheckmark color={`var(--bs-success)`} size={13} />
                    <p className='text-ellipsis text-capitalize mb-0 text-muted ms-1'><small>{user && user.claims.role}</small></p>
                  </div>
                  :
                  <Skeleton height={12} />
              }
            </div>
          </Button>
        </OverlayTrigger>
      </div>
      {
        location && location.pathname && location.pathname.includes('settings') ?
          <div className='sidebar-body'>
            <ul className='border-top'>
              <li>
                <NavLink to="/admin/dashboard" className="back-to-dash bg-dark text-white shadow-sm border rounded">
                  <div className='link-icon'><BsArrowLeft size={18} /></div>
                  <div className={sidenavCollapsed ? 'collapsed-side-hide' : 'link-label'}>Back to Dashboard</div>
                </NavLink>
              </li>
              <li className='mt-4'>
                <NavLink to="/admin/settings/account">
                  <div className='link-icon'><BsPersonLock size={18} /></div>
                  <div className={sidenavCollapsed ? 'collapsed-side-hide' : 'link-label'}>Account</div>
                </NavLink>
              </li>
              <li>
                <NavLink to="/admin/settings/company">
                  <div className='link-icon'><IoBriefcaseOutline size={18} /></div>
                  <div className={sidenavCollapsed ? 'collapsed-side-hide' : 'link-label'}>Manage Business</div>
                </NavLink>
              </li>
              <li>
                <NavLink to="/admin/settings/general">
                  <div className='link-icon'><RiListSettingsLine size={18} /></div>
                  <div className={sidenavCollapsed ? 'collapsed-side-hide' : 'link-label'}>General Settings</div>
                </NavLink>
              </li>
              {
                user && user.claims && user.claims.role === 'admin' ?
                  <li>
                    <NavLink to="/admin/settings/manage-users">
                      <div className='link-icon'><BsPersonGear size={18} /></div>
                      <div className={sidenavCollapsed ? 'collapsed-side-hide' : 'link-label'}>Manage Users</div>
                    </NavLink>
                  </li>
                  :
                  null
              }
              <li>
                <NavLink to="/admin/settings/reminders">
                  <div className='link-icon'><BsAlarm size={18} /></div>
                  <div className={sidenavCollapsed ? 'collapsed-side-hide' : 'link-label'}>Reminders</div>
                </NavLink>
              </li>
              {/* <li>
                <NavLink to="/admin/settings/help-support">
                  <div className='link-icon'><BsQuestionCircle size={18} /></div>
                  <div className={sidenavCollapsed ? 'collapsed-side-hide' : 'link-label'}>Help & Support</div>
                </NavLink>
              </li> */}
              <hr className='mb-0' />
              <li>
                <Button
                  variant='link'
                  className='text-decoration-none text-muted p-0 m-0 w-100'
                  onClick={handleLogout}
                >
                  <div className='logout-container'>
                    <div className='link-icon'><IoLogOutOutline size={18} /></div>
                    <div className={sidenavCollapsed ? 'collapsed-side-hide' : 'link-label'}>Logout</div>
                  </div>
                </Button>
              </li>
            </ul>
          </div>
          :
          <div className='sidebar-body'>
            <ul className='border-top'>
              <li>
                <NavLink to="/admin/dashboard" >
                  <div className='link-icon'><IoGridOutline size={18} /></div>
                  <div className={sidenavCollapsed ? 'collapsed-side-hide' : 'link-label'}>Dashboard</div>
                </NavLink>
              </li>
              <li>
                <NavLink to="/admin/search-lead">
                  <div className='link-icon'><IoSearchOutline size={18} /></div>
                  <div className={sidenavCollapsed ? 'collapsed-side-hide' : 'link-label'}>Search Lead</div>
                </NavLink>
              </li>
              <div className='px-4 text-secondary'>
                <h6 className='mt-3 mb-0 fw-normal small'><small>CRM</small></h6>
              </div>
              <li>
                <NavLink to="/admin/leads">
                  <div className='link-icon'><IoBarChartOutline size={18} /></div>
                  <div className={sidenavCollapsed ? 'collapsed-side-hide' : 'link-label'}>Leads</div>
                </NavLink>
              </li>
              <li>
                <NavLink to="/admin/managers">
                  <div className='link-icon'><BsPersonVcard size={18} /></div>
                  <div className={sidenavCollapsed ? 'collapsed-side-hide' : 'link-label'}>Managers</div>
                </NavLink>
              </li>
              <li>
                <NavLink to="/admin/executives">
                  <div className='link-icon'><BsPersonVcard size={18} /></div>
                  <div className={sidenavCollapsed ? 'collapsed-side-hide' : 'link-label'}>Executives</div>
                </NavLink>
              </li>
              <li>
                <NavLink to="/admin/parties">
                  <div className='link-icon'><IoPeopleOutline size={18} /></div>
                  <div className={sidenavCollapsed ? 'collapsed-side-hide' : 'link-label'}>Parties</div>
                </NavLink>
              </li>
              <li>
                <NavLink to="/admin/properties">
                  <div className='link-icon'><BsBuildings size={18} /></div>
                  <div className={sidenavCollapsed ? 'collapsed-side-hide' : 'link-label'}>Properties</div>
                </NavLink>
              </li>
              <div className='px-4 text-secondary'>
                <h6 className='mt-3 mb-0 fw-normal small'><small>BILLING</small></h6>
              </div>
              <li>
                <NavLink to="/admin/bookings">
                  <div className='link-icon'><BsJournalText size={18} /></div>
                  <div className={sidenavCollapsed ? 'collapsed-side-hide' : 'link-label'}>Bookings</div>
                </NavLink>
              </li>
              <li>
                <NavLink to="/admin/receipts">
                  <div className='link-icon'><IoReceiptOutline size={18} /></div>
                  <div className={sidenavCollapsed ? 'collapsed-side-hide' : 'link-label'}>Receipts</div>
                </NavLink>
              </li>
              <li>
                <NavLink to="/admin/expenses">
                  <div className='link-icon'><BsReceipt size={18} /></div>
                  <div className={sidenavCollapsed ? 'collapsed-side-hide' : 'link-label'}>Expenses</div>
                </NavLink>
              </li>
              <div className='px-4 text-secondary'>
                <h6 className='mt-3 mb-0 fw-normal small'><small>REPORTS</small></h6>
              </div>
              <li>
                <NavLink to="/admin/ledger">
                  <div className='link-icon'><IoJournalOutline size={18} /></div>
                  <div className={sidenavCollapsed ? 'collapsed-side-hide' : 'link-label'}>Ledger</div>
                </NavLink>
              </li>
            </ul>
          </div>
      }
      {
        user && user.claims && user.claims.role === 'admin' ?
          <div className='sidebar-foot border-top'>
            <ul>
              <li>
                <NavLink to="/admin/settings/account">
                  <div className='link-icon'><IoSettingsOutline color={`var(--bs-orange)`} size={18} /></div>
                  <div className={sidenavCollapsed ? 'collapsed-side-hide' : 'link-label'}>Settings</div>
                </NavLink>
              </li>
            </ul>
          </div>
          :
          null
      }
    </div>
  );
}

export default SideBar;
